// GAEA-JS: 2026-09-25 — Toggle de columnas (2/4/6) en PLP, solo desktop
(function () {
  var STORAGE_KEY = 'fp-grid-columns';
  var DESKTOP_QUERY = '(min-width: 768px)';

  function applyColumns(columns) {
    if (!window.matchMedia(DESKTOP_QUERY).matches) return;
    document.querySelectorAll('[data-collection-products] .grid').forEach(function (grid) {
      grid.style.gridTemplateColumns = 'repeat(' + columns + ', minmax(0, 1fr))';
    });
    document.querySelectorAll('[data-grid-toggle] .grid-toggle__btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.dataset.gridColumns === String(columns));
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('[data-collection-products]');
    var defaultColumns = container
      ? (container.className.match(/collection-items--(\d+)/) || [])[1]
      : null;
    var saved = sessionStorage.getItem(STORAGE_KEY) || defaultColumns;
    if (saved) applyColumns(saved);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-grid-toggle] .grid-toggle__btn');
    if (!btn) return;
    var columns = btn.dataset.gridColumns;
    sessionStorage.setItem(STORAGE_KEY, columns);
    applyColumns(columns);
  });
})();